import React, { useEffect, useState } from 'react';
import { Header } from '../../../header/Header';
import MainContent from '../MainContent/MainContent';
import { MainHeader } from '../MainHeader/MainHeader';
import HorizontalNavigation from '../navigation/HorizontalNavigation/HorizontalNavigation';
import CrmXFooter from '../Footer/CrmXFooter';
import BackgroundArt from '../Background/BackgroundArt';
import * as S from './MainLayout.styles';
import { Outlet, useLocation } from 'react-router-dom';
//import { MEDICAL_DASHBOARD_PATH, NFT_DASHBOARD_PATH } from '../../../../router/AppRouter';
import { useResponsive } from '../../../../hooks/useResponsive';
//import { References } from '../../../../../components/common/References/References';

const MainLayout: React.FC = () => {
  const [isTwoColumnsLayout, setIsTwoColumnsLayout] = useState(true);
  const [siderCollapsed, setSiderCollapsed] = useState(true);
  const { isDesktop } = useResponsive();
  const location = useLocation();

  const toggleSider = () => setSiderCollapsed(!siderCollapsed);

  // useEffect(() => {
  //   setIsTwoColumnsLayout([MEDICAL_DASHBOARD_PATH, NFT_DASHBOARD_PATH].includes(location.pathname) && isDesktop);
  // }, [location.pathname, isDesktop]);

  return (
    <S.LayoutMaster>
      <BackgroundArt />
      <MainHeader isTwoColumnsLayout={isTwoColumnsLayout}>
        <Header toggleSider={toggleSider} isSiderOpened={!siderCollapsed} isTwoColumnsLayout={isTwoColumnsLayout} />
      </MainHeader>
      <HorizontalNavigation />
            <S.LayoutMain>
              <S.MainWrapper>
                <S.TopSpacer />
                <S.ContentContainer>
                  <MainContent id="main-content" $isTwoColumnsLayout={isTwoColumnsLayout}>
                    <div>
                      <Outlet />
                    </div>
                  </MainContent>
                  {/* {!isTwoColumnsLayout && <References />} */}
                </S.ContentContainer>
              </S.MainWrapper>
              <CrmXFooter />
            </S.LayoutMain>
    </S.LayoutMaster>
  );
};

export default MainLayout;
